// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DocumentLink_wrapper__LY_ob","text":"DocumentLink_text__reSP_","icon":"DocumentLink_icon__W5nzG"};